import { ProductOption } from "@lib/swell/storefront-data-hooks/src/types"
import { classNames } from "core/utils"
import { useFormikContext, useField } from "formik"
import { useEffect, useCallback } from "react"
import { Selection } from "./ConfiguratorProductForm"
interface TextFieldProps {
  option: ProductOption
  updateTextFieldSelectionChange: any
  selections: Selection[]
  value?: string
}
const TextField = ({
  option,
  updateTextFieldSelectionChange,
  selections,
  value,
}: TextFieldProps) => {
  const { id, name, input_hint, description } = option
  const [input] = useField(name)

  const { isSubmitting } = useFormikContext()
  return (
    <div className={classNames("border border-gray-300 rounded-lg p-4")}>
      <label htmlFor="email-address" className="block text-sm font-medium text-gray-700">
        {name}
      </label>
      <span
        className="text-sm text-gray-500"
        dangerouslySetInnerHTML={{ __html: description }}
      ></span>

      <div className="mt-1">
        <input
          type="text"
          {...input}
          placeholder={input_hint}
          value={value}
          disabled={isSubmitting}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            input.onChange({ target: { value: event.target.value, name } })
            updateTextFieldSelectionChange(name, id, event.target.value)
          }}
          className="block w-full border-gray-300 rounded-md shadow-xs focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
        />
      </div>
    </div>
  )
}
export default TextField
